import { createContext } from "react";
import { ISummaryReportDashboardContext } from "./SummaryReportDashboardContextInterfaces";
import { allElements } from "constants/constants";
import { initialSummaryReportDashboardFilters } from "pages/Corporate/Locations/MillDashboards/SummaryReportDashboard/components/SummaryReportDashboardFilters/useSummaryReportDashboardFilters";

export const initialState: ISummaryReportDashboardContext = {
    selectedProductionLine: allElements,
    selectedProductionLineName: "",
    filters: initialSummaryReportDashboardFilters,
    showFilters: false,
    totalDowntimeSeconds: undefined,
    handleSetTotalDowntimeSeconds: () => {},
    handleFiltersChange: () => {},
    handleSelectedProductionLineChange: () => {},
    handleShowFiltersChange: () => {},
    showAllProductionLines: true,
    handleShowAllProductionLinesChange: () => {},
    handleSetSelectedFailureType: () => {},
    selectedFailureType: undefined,
    handleSetSelectedFailureCode: () => {},
    selectedFailureCode: undefined,
    handleSetSelectedSecondaryFailureCode: () => {},
    selectedSecondaryFailureCode: undefined,
    resetSelections: () => {},
    selectedDowntimeBar: null,
    handleSetSelectedDowntimeBar: () => {},
    selectedDowntimeBarTitle: "",
    handleSelectedDowntimeBarTitle: () => {},
    selectedMachineCenterByCode: undefined,
    handleSetSelectedMachineCenterByCode: () => {},
    handleSetFiltersDefault: async () => {},
    handleRemoveDefaultFilters: async () => {},
    userFiltersDefault: null,
    loadingDefaultOperations: false,
};

export const SummaryReportDashboardContext = createContext(initialState);
